import { UPDATE_CONFIG } from '../actions/types/ConfigTypes';
import runtimeConfig from '../../../../config/runtime.json';
import projectRuntimeConfig from '../../../../../config/runtime.json';

const initialState = { ...runtimeConfig, ...projectRuntimeConfig };

export default (state = initialState, action) => {
  switch (action.type) {
  case UPDATE_CONFIG:
    return {
      ...state,
      ...action.payload,
    };
  default:
    return state;
  }
};
